var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button } from '@dixa/lib-shared-habla';
import classnames from 'classnames';
import { Component } from 'react';
import { buttonize } from '../../../../utils/a11y';
import styles from './dropdownTeam.module.scss';
export class Dropdown extends Component {
    constructor(props) {
        super(props);
        this.state = {
            dropdownOpen: false,
        };
        this.dropdownWrap = null;
        this.timeout = null;
        this.setDropdownWrap = this.setDropdownWrap.bind(this);
        this.handleClickOutsideDropdown =
            this.handleClickOutsideDropdown.bind(this);
        this.handleDropdownClick = this.handleDropdownClick.bind(this);
        this.handleDropdownToggle = this.handleDropdownToggle.bind(this);
    }
    shouldComponentUpdate(nextProps, nextState) {
        const { children } = this.props;
        const { dropdownOpen } = this.state;
        return (nextProps.children !== children || nextState.dropdownOpen !== dropdownOpen);
    }
    componentDidUpdate(prevProps, prevState) {
        const { dropdownOpen } = this.state;
        if (dropdownOpen !== prevState.dropdownOpen) {
            this.timeout = setTimeout(() => {
                window[dropdownOpen ? 'addEventListener' : 'removeEventListener']('click', this.handleClickOutsideDropdown);
            });
        }
    }
    componentWillUnmount() {
        window.removeEventListener('click', this.handleClickOutsideDropdown);
        if (this.timeout) {
            window.clearInterval(this.timeout);
        }
    }
    setDropdownWrap(element) {
        this.dropdownWrap = element;
    }
    handleClickOutsideDropdown(event) {
        if (!this.dropdownWrap || !(event.target instanceof Node)) {
            return;
        }
        if (this.dropdownWrap &&
            event.target !== this.dropdownWrap &&
            !this.dropdownWrap.contains(event.target)) {
            this.close();
        }
    }
    handleDropdownToggle() {
        const { dropdownOpen } = this.state;
        this.setState({
            dropdownOpen: !dropdownOpen,
        });
    }
    handleDropdownClick(event) {
        event.stopPropagation();
        this.close();
    }
    close() {
        window.removeEventListener('click', this.handleClickOutsideDropdown);
        this.setState({
            dropdownOpen: false,
        });
    }
    render() {
        const _a = this.props, { children, className } = _a, otherProps = __rest(_a, ["children", "className"]);
        const { dropdownOpen } = this.state;
        const rootClass = classnames({
            [styles.dropdownTeam]: true,
        }, className);
        return (_jsxs("div", Object.assign({}, otherProps, { className: rootClass, role: "menu", "aria-expanded": dropdownOpen }, { children: [_jsx("div", Object.assign({ className: styles.dropdownToggleTeam }, buttonize(this.handleDropdownToggle), { children: _jsx(Button, Object.assign({ variant: "secondary" }, { children: "Actions" })) })), dropdownOpen && (_jsx("div", Object.assign({ ref: this.setDropdownWrap, className: styles.dropdownWrapTeam }, buttonize(this.handleDropdownClick), { children: typeof children === 'function' ? children() : children })))] })));
    }
}
